<template>
<div class="next">
	<div class="van-nav-bar van-hairline--bottom custom-nav-bar">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback" @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{xuanfeidata.xuanfei_name || '加载中...'}}
			</div>
			<div class="van-nav-bar__right van-haptics-feedback"  @click="toService">
				<i class="van-badge__wrapper van-icon" style="font-size: 24px;">
					<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA4BJREFUWEfFlmnIpnMUxn/XF75Z840SgxAa2xiRJRnLkMlS82WSqcE09hBlnQxNQsaSyZJMmozsJNuMhvggGmQJKVtRJqbIJ5eux7nf7nk9z/vc91OaU/+e5f6fc677LNc5YhuLtrF/egGwfShwJHAIcHCdn4GP62yS9Gyfl+oEwPZuwBXAlcD2YxxsAO6W9EIXIGMB2F5ajvcGvgFWA1/X+QrYBdgHmAUcBSwux2uAFZI+nwnIjADK+f1l4AHgNkk/5bftHYH9gM2SAmggtk8DrgJOBD4C5jc6w4CMBGB7PvBiKS2UtNb2/sAlwEn11o3NP4EvgbWSVhaQO4BrgbeAMyX90RmA7YOAl4E9gBuB24Gby/kOY3L7LrAyNWB7HXAO8LSkc/sAWAFcBzwCXA88BiS0fWQJ8BLwarXLsZLemW5gaApsp3BSVGm1J4DD+nhu3b2hvi8H7pV02VgAts8C0svPAd8Bl07ovFGbC7wH5KXmSfq+be8/EbD9OLAIOBl4rafz5Hx6rp8EUjcp6oeBN1PQjd0pALbTz6n6o+thcndKTwDhgLTmNdP0Qk7Ht/7bSdLv+d0GcH4VW0+fU9fTiscACXGKLUBGyS2S0lVbAbipWm0SAJuB5ZLuKQ64PHT8fwLIAPqwdTZICoiB2J5dz3pFICFJFEbJRiD8PnAs6e+ZQmU7zLjviDtDUzATgCmFrvmxvQpY1gdAmOuhEQonSEoldxbbd9ZQis6WasVGfzBbphfhnsC3deOvotCQUmRnSb919v5vHYTGLyid04vQ5gHrJJ3X2BpGROnlp4A5wOt1cYGkMGNnsf0MsAB4VNJi2xcDtwKzJf0wEkDbg+0HgYuAsTVg+wDgQElhw0RgfZwBGUKf2P4iRCfp6raPLhvRL7WGzZX0Wct4IrKpjIV+TwWOC9fb3qu2pwHw2i0yX/L2n/YCUA7TnnMkTY1k2/nvDGBXIC2aZeSVup/8r5e0xvbuwPPAG5KyoGwlYyPQ3LadbTgg0l4jxXYKeZGkjba3q8Vmi6Szhyl1BtACMqu9A45CYjtrW0Z5tqq08dAu6g2gBSS8sRB4uxksFf7M/zzLKnZfjqQfRwGdCIDtbEgftIzeBRwOHAH8WqvYqqZoZ0rZpAAy29NmjaT1unsLymfnWUiABXq0HZCvVrShZ09TtoFkzoYpzdxBMYZ7vr8HyNeRjAaHC/gAAAAAElFTkSuQmCC">
					</i>
			</div>
		</div>
	</div>
	
	<!-- 加载状态 -->
	<div v-if="loading" class="loading-container">
		<van-loading type="spinner" size="24px">加载中...</van-loading>
	</div>
	
	<!-- 主要内容 -->
	<div v-else class="content">
		<div class="swiper">
			<swiper class="swiper" :options="bannerSwiperOption" v-if="xuanfeidata.img_url && xuanfeidata.img_url.length">
			  <swiper-slide v-for="(v,key) in xuanfeidata.img_url" :key="key">
					<img class="banner_img" :src="v" />
					<span class="premium-badge">
						<i>
							{{$t('home.gaoji')}}
						</i>
					</span>
			  </swiper-slide>
			</swiper>
			<div v-else class="image-placeholder">
				<van-empty description="暂无图片" />
			</div>
			
		  <div class="swiper-fot">
		  	<i class="van-badge__wrapper van-icon logo-icon">
		  		<img class="van-icon__image" src="img/logo.png">
			</i>
		  	<div class="verification-badges" @click="toService">
		  		<span class="badge">
		  			<i class="van-badge__wrapper van-icon">						
		  				<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC">
		  				</i>
		  			{{$t('home.smrz')}}
		  		</span>
		  		<span class="badge">
		  			<i class="van-badge__wrapper van-icon">						
		  				<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC">
		  				</i>
		  			{{$t('home.videorz')}}
		  		</span>
		  	</div>
		  </div>
		</div>
		
		<h1 class="section-title">
			{{xuanfeidata.xuanfei_name || '未知名称'}}
			<span class="serial-number" v-if="xuanfeidata.sn">
				{{xuanfeidata.sn}}
			</span>
		</h1>
		
		<div class="profile-section">
			<div class="profile-left">
				<h1 class="section-subtitle">
					{{$t('choose.jianjie')}}
				</h1>
				<p class="profile-info">
					{{$t('home.sg')}}: {{xuanfeidata.sg || '未知'}}cm {{$t('home.xw')}}：{{xuanfeidata.xw || '未知'}}
				</p>
				<div class="tags-container" v-if="xuanfeidata.tags_arr && xuanfeidata.tags_arr.length">
					<span 
						v-for="(val,index) in xuanfeidata.tags_arr" 
						:key="index" 
						class="tag"
						:class="`tag-${index % tagColors.length}`"
						:style="getTagStyle(index)"
					>
						{{val}}
					</span>
				</div>
				<div v-else class="no-tags">
					暂无标签
				</div>
				<p class="star-rating">
					{{$t('home.star')}}：
					<span v-for="(numa,indexs) in xuanfeidata.star || 0" :key="indexs" class="star"></span>
					<span v-if="!xuanfeidata.star" class="no-star">暂无评分</span>
				</p>
				<p class="profile-info">
					{{$t('home.diqu')}}：{{xuanfeidata.class_name || '未知'}}
				</p>
				<p class="profile-info">
					{{$t('choose.move')}}：{{$t('possible')}}
				</p>
			</div>
			<div class="profile-right">
				<img src="img/zan.c28032c8.png" alt="">
				<span class="like-text">
					{{$t('thumb')}}
				</span>
			</div>
			<a class="action-button" @click="toService">
				{{$t('choose.click')}}
			</a>
			
		</div>
		
		<div class="detail-section">
			<h1 class="section-subtitle">
				{{$t('choose.detail')}}
			</h1>
			<ul class="image-gallery" v-if="xuanfeidata.img_url && xuanfeidata.img_url.length">
				<li v-for="(v,key) in xuanfeidata.img_url" :key="key">
					<img :src="v" alt="">
				</li>			
			</ul>
			<div v-else class="no-images">
				<van-empty description="暂无详情图片" />
			</div>
			
			<h1 class="section-subtitle video-title">
				{{$t('choose.videodetail')}}
			</h1>
			<div class="video-container" v-if="xuanfeidata.video_url">
			  <video width="100%" controls :src="xuanfeidata.video_url"></video>
			</div>
			<div v-else class="no-video">
				<van-empty description="暂无视频" />
			</div>
		</div>

		<div class="description-section">
			<h2 class="description-title">
				{{$t('privacyPolicy')}}
			</h2>
			<p class="description-content">
				{{$t('romanticDescription')}}
			</p>
		</div>
	</div>

	<van-popup
	  v-model="show"
	  closeable
	  close-icon="close"
	  get-container="#app"
	  :style="{ height:'88%',width:'90%' }"
	  v-if="xuanfeidata.lottery"
	>
		<Game 
			:pkey="xuanfeidata.lottery.key" 
			:pid="xuanfeidata.lottery.id" 
			:ppic="xuanfeidata.img_url && xuanfeidata.img_url[0] ? xuanfeidata.img_url[0] : ''"
		/>
	</van-popup>
</div>
</template>

<script>
import Game from '../../common/Game'
export default {
	components: {
	  Game
	},
	data() {
		return {
			xuanfeidata: {},
			show: false,
			loading: true,
			cover: "",
			bannerSwiperOption: {
			  loop: true,
			  speed:1000,
			  autoplay:true,
			  pagination: {
			    el: '.swiper-pagination'
			  },
			},
			// 定义多种颜色组合
			tagColors: [
				{ from: '#667eea', to: '#764ba2' },      // 蓝紫色
				{ from: '#f093fb', to: '#f5576c' },      // 粉红色
				{ from: '#4facfe', to: '#00f2fe' },      // 蓝色
				{ from: '#43e97b', to: '#38f9d7' },      // 绿色
				{ from: '#fa709a', to: '#fee140' },      // 橙粉色
				{ from: '#a8edea', to: '#fed6e3' },      // 浅蓝粉
				{ from: '#ff9a9e', to: '#fecfef' },      // 粉紫色
				{ from: '#a6c0fe', to: '#f68084' },      // 蓝粉色
				{ from: '#d4fc79', to: '#96e6a1' },      // 黄绿色
				{ from: '#84fab0', to: '#8fd3f4' },      // 青蓝色
				{ from: '#a3bded', to: '#6991c7' },      // 深蓝色
				{ from: '#fbc2eb', to: '#a6c1ee' }       // 紫粉色
			]
		};
	},
	methods: {
		back(){
		  return window.history.back();
		},
		toService(){
		  if(this.$store.getters.getBaseInfo.iskefu == 1){
		    this.$router.push("ServiceOnline");
		  }else {
		    this.$toast.fail(this.$t('common.noallow'));
		  }
		},
		getxuanfeidata() {
			this.loading = true;
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.xuanfeidata = res.data || {};
				this.cover = res.data.cover;
			}).catch(error => {
				console.error('获取数据失败:', error);
				this.$toast('获取数据失败');
				this.xuanfeidata = {};
			}).finally(() => {
				this.loading = false;
			});
		},
		yuyue() {
			this.$toast('请联系顾问或接待员');
		},
		// 获取标签样式
		getTagStyle(index) {
			const colorIndex = index % this.tagColors.length;
			const color = this.tagColors[colorIndex];
			return {
				background: `linear-gradient(135deg, ${color.from}, ${color.to})`
			};
		},
		// 获取标签类名（用于CSS备用）
		getTagClass(index) {
			return `tag-${index % this.tagColors.length}`;
		}
	},
	created() {
		
		this.getxuanfeidata();
	}
};
</script>

<style scoped>
/* 加载状态 */
.loading-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 200px;
}

/* 禁用状态按钮 */
.action-button.disabled {
	background: #ccc !important;
	cursor: not-allowed;
	opacity: 0.6;
}

.action-button.disabled:hover {
	transform: none !important;
	box-shadow: none !important;
}

/* 空状态样式 */
.no-tags,
.no-star,
.no-images,
.no-video {
	color: #999;
	font-size: 0.9rem;
	text-align: center;
	padding: 1rem;
}

.image-placeholder {
	height: 28rem;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f5f5f5;
}

/* 标签样式 - 使用动态类名 */
.tags-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: 1rem 0;
}

.tag {
    color: #fff;
    display: inline-block;
    border-radius: .33333rem;
    margin-right: .33333rem;
    font-size: 12px;
    padding: .33333rem 1rem;
    margin-bottom: .33333rem;
    border: none;
    cursor: default;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.tag:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

/* 预定义的标签颜色类（备用） */
.tag-0 { background: linear-gradient(135deg, #667eea, #764ba2); }
.tag-1 { background: linear-gradient(135deg, #f093fb, #f5576c); }
.tag-2 { background: linear-gradient(135deg, #4facfe, #00f2fe); }
.tag-3 { background: linear-gradient(135deg, #43e97b, #38f9d7); }
.tag-4 { background: linear-gradient(135deg, #fa709a, #fee140); }
.tag-5 { background: linear-gradient(135deg, #a8edea, #fed6e3); }
.tag-6 { background: linear-gradient(135deg, #ff9a9e, #fecfef); }
.tag-7 { background: linear-gradient(135deg, #a6c0fe, #f68084); }
.tag-8 { background: linear-gradient(135deg, #d4fc79, #96e6a1); }
.tag-9 { background: linear-gradient(135deg, #84fab0, #8fd3f4); }
.tag-10 { background: linear-gradient(135deg, #a3bded, #6991c7); }
.tag-11 { background: linear-gradient(135deg, #fbc2eb, #a6c1ee); }

/* 导航栏样式 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white !important;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left {
    padding: 0 15px;
}

.van-nav-bar__arrow {
    color: white !important;
    font-size: 1.2rem;
    font-weight: bold;
}

.van-nav-bar__right .van-icon__image {
    filter: brightness(0) invert(1);
}

/* 轮播图区域 */
.swiper {
    width: 100%;
    position: relative;
}

.swiper .swiper-slide {
    height: 28rem;
    overflow: hidden;
    position: relative;
}

.swiper .swiper-slide img {
    width: 100%;
    display: block;
}

.premium-badge {
    position: absolute;
    z-index: 99;
    top: -5.33333rem;
    right: -8.66667rem;
    width: 10rem;
    height: 10rem;
    background: linear-gradient(135deg, #ff9f43, #ff6b6b);
    transform: rotate(45deg);
    opacity: 0.9;
}

.premium-badge i {
    position: absolute;
    bottom: 0;
    left: 1.83333rem;
    color: white;
    font-weight: 600;
}

/* 底部信息栏 */
.swiper-fot {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2.66667rem;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 1.66667rem 1.66667rem 0 0;
    z-index: 9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2% 0 5%;
}

.logo-icon {
    font-size: 81px;
}

.verification-badges {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.badge {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ff9f43   , #ff6b6b   );
    color: white;
    font-weight: 600;
    margin-left: .2rem;
    padding: .2rem .6rem;
    font-size: 0.88rem;
}

.badge:first-child {
    border-radius: 0 0 0 1rem;
}

.badge:last-child {
    border-radius: 0 1rem 0 0;
}

/* 标题区域 */
.section-title {
    font-size: 18px;
    padding: 14px 0px;
    color: rgb(255, 255, 255);
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
}

.serial-number {
    margin-left: 10px;
    font-size: 16px;
}

/* 个人信息区域 */
.profile-section {
    display: flex;
    text-align: left;
    width: 100%;
    margin: 0 auto;
    padding: .33333rem 3%;
    position: relative;
    background: white;
    border-bottom: 1px solid #f0f0f0;
}

.profile-left {
    max-width: 100%;
    flex: 1;
}

.section-subtitle {
    padding: 0px 0px 10px;
    color: #333;
    font-size: 1rem;
    font-weight: 600;
}

.profile-info {
    font-size: .83333rem;
    color: #666;
    margin: 0.5rem 0;
}

.star-rating {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .83333rem;
    color: #666;
}

.star {
    width: 1rem;
    height: 1rem;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%230f3460"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>') no-repeat 50%/100%;
    margin-left: 0.2rem;
}

.profile-right {
    position: absolute;
    right: 1.66667rem;
    text-align: center;
    color: #333;
    display: none;
}

.profile-right img {
    width: 3.66667rem;
    display: block;
}

.like-text {
    font-size: 0.8rem;
    color: #666;
}

.action-button {
    position: absolute;
    right: 1.66667rem;
    bottom: .66667rem;
    color: #fff;
    padding: .33333rem 1rem;
    background: linear-gradient(135deg, #ff9f43, #ff6b6b);
    border-radius: .33333rem;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    cursor: pointer;
}

.action-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 详情区域 */
.detail-section {
    width: 100%;
    padding: .66667rem 3%;
    background: white;
}

.image-gallery {
    list-style: none;
    padding: 0;
    margin: 0;
}

.image-gallery li {
    margin-top: .33333rem;
}

.image-gallery li img {
    width: 100%;
    border-radius: 8px;
}

.video-title {
    padding-bottom: 0px;
}

.video-container {
    padding-top: 10px;
}

.video-container video {
    width: 100%;
    border-radius: 8px;
}

/* 描述区域 */
.description-section {
    text-align: left;
    padding: 1rem 3%;
    background: white;
}

.description-title {
    color: #2a1468;
    font-size: .93333rem;
    margin-bottom: 1rem;
}

.description-content {
    padding: .66633rem 0;
    color: #534589;
    line-height: 1.6;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .swiper .swiper-slide {
        height: 20rem;
    }
    
    .premium-badge {
        top: -4rem;
        right: -6rem;
        width: 8rem;
        height: 8rem;
    }
    
    .section-title {
        font-size: 16px;
        padding: 12px 0px;
    }
    
    .serial-number {
        font-size: 14px;
    }
    
    .tag {
        font-size: 11px;
        padding: .25rem .8rem;
    }
}

/* 动画效果 */
@keyframes fadeInUp {
    from { 
        opacity: 0; 
        transform: translateY(15px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.profile-section,
.detail-section,
.description-section {
    animation: fadeInUp 0.4s ease forwards;
}
</style>
